import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App.js';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js